import { reactive, ref, computed, watch } from 'vue';
import { defineStore } from 'pinia';
import { useAtomicSetter } from '@/composables/useAtomicSetter.js';

const useAgenciesStore = defineStore('agencies', () => {
  const filters = reactive({
    search_text: '',
    sort_by: 'name',
    sort_order: 'asc',
    page: 1,
    per_page: 25,
  });

  const shouldResetFilters = ref(true);

  const stateRefs = {
    shouldResetFilters,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const setFilters = (newFilters) => {
    Object.assign(filters, newFilters);
  };

  const resetFilters = () => {
    Object.assign(filters, { page: 1, search_text: '' });
  };

  watch(
    () => filters.search_text,
    (newSearchText, oldSearchText) => {
      if (newSearchText !== oldSearchText) {
        setFilters({ page: 1 });
      }
    }
  );

  return { filters, setFilters, resetFilters, ...stateRefs, setAtomic };
});

const useAgencyDrawerStore = defineStore('agency-drawer', () => {
  const agencyId = ref(null);

  const isOpen = computed(() => !!agencyId.value);

  const stateRefs = {
    agencyId,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const closeDrawer = () => {
    setAtomic('agencyId', null);
  };

  return {
    ...stateRefs,
    isOpen,
    setAtomic,
    closeDrawer,
  };
});

export { useAgenciesStore, useAgencyDrawerStore };
